/** 创建指定 HTML DOM 元素 */
export function createElement<T extends keyof HTMLElementTagNameMap>(
    elem: T,
    attrs?: Partial<{ [k in keyof HTMLElementTagNameMap[T]]: Partial<HTMLElementTagNameMap[T][k]> }>,
    content?: string,
    parent?: HTMLElement,
): HTMLElementTagNameMap[T] {
    const dom = document.createElement(elem);
    // if (attrs) for (const k of Object.keys(attrs)) dom.setAttribute(k, attrs[k] as any);
    if (attrs) for (const k of Object.keys(attrs)) dom[k] = attrs[k];
    dom.innerHTML = content || '';
    parent?.appendChild(dom);
    return dom;
}

/** 根据字符创创建 HTML DOM 元素 */
export function createElementByHtmlString(html: string, parent?: HTMLElement): DocumentFragment {
    const div = document.createElement('div');
    const fragment = document.createDocumentFragment();
    div.innerHTML = html;
    fragment.append(...Array.from(div.childNodes));
    // const children = Array.from(div.children);
    // for (const c of children) fragment.appendChild(c);
    if (parent) parent.appendChild(fragment);
    return fragment;
}

/** 使用 script 标签加载脚本 */
export async function loadScript(src: string, onload?: () => void, attrs?: Partial<{ [k in keyof HTMLScriptElement]: any }>): Promise<void> {
    try {
        const script = createElement('script', Object.assign(attrs || {}, { type: 'text/javascript', src }));
        return new Promise((resolve, reject) => {
            script.addEventListener('load', (ev) => {
                console.debug(`[Act][loadScript] ${script.src} 加载成功`);
                onload?.();
                resolve(void 0);
            });
            script.addEventListener('error', (ev) => {
                console.error(`[Act][loadScript] ${script.src} 加载失败：`, ev);
                reject(ev.error);
            });
            document.body.appendChild(script);
        });
    } catch (err) {
        console.error(`[Act][loadScript] ${src} 加载失败：`, err);
        return;
    }
}

/** 使用 link 标签加载样式文件 */
export function loadStyleByUrl(href: string, onload?: () => void, attrs?: object): Promise<void> {
    const link = createElement('link', Object.assign(attrs || {}, { rel: 'stylesheet', type: 'text/css', href }));
    return new Promise((resolve, reject) => {
        link.addEventListener('load', (ev) => {
            console.debug(`[Act][loadStyle] ${link.href} 加载成功`);
            onload?.();
            resolve(void 0);
        });
        link.addEventListener('error', (ev) => {
            console.error(`[Act][loadStyle] ${link.href} 加载失败：`, ev);
            reject(ev.error);
        });
        document.head.appendChild(link);
    });
}

/** 使用 style 标签动态加载样式 */
export function loadStyle(content: string) {
    createElement('style', { type: 'text/css' }, content, document.head);
}
